<template>
  <b-container class="container-rda">
    <b-row>
      <b-col>
        <Breadcrumb :breadcrumb="breadcrumb" />
      </b-col>
    </b-row>

    <b-row v-if="canEdit">
      <b-col>
        <b-tabs class="tab-content" content-class="mt-5">
          <b-tab title="Dados dos contratantes">
            <b-row v-if="enrollmentsResponsibles">
              <b-col
                v-for="(
                  responsible, index
                ) in enrollmentsResponsibles.EnrollmentResponsibles"
                :key="index"
                cols="12"
              >
                <b-row>
                  <b-col cols="12">
                    <h2 class="purple bold">
                      {{ responsible.name }}
                    </h2>
                  </b-col>
                </b-row>

                <b-row class="mb-4">
                  <b-col cols="12" md="3" class="mb-3">
                    <ProfilePhoto
                      :modalId="`contractor + ${index}`"
                      :photo="
                        typeof responsible.photo !== 'string'
                          ? photoContractor[index]
                          : responsible.photo
                      "
                      :callback="(photo) => setNewPhotoContractor(photo, index)"
                    />
                  </b-col>

                  <b-col cols="12" md="9">
                    <b-row>
                      <b-col cols="12" md="6" class="mb-3">
                        <StandardInput
                          type="text"
                          name="name"
                          label="Nome"
                          v-model="responsible.name"
                        />
                      </b-col>

                      <b-col cols="12" md="6" class="mb-3">
                        <StandardInput
                          type="email"
                          name="email"
                          label="E-mail"
                          v-model="responsible.email"
                        />
                      </b-col>
                    </b-row>

                    <b-row>
                      <b-col cols="12">
                        <h5>Documentos</h5>
                      </b-col>
                    </b-row>

                    <b-row>
                      <b-col cols="12" md="4" class="mb-3">
                        <StandardInput
                          type="text"
                          name="cpf"
                          label="CPF"
                          v-mask="['###.###.###-##']"
                          v-model="responsible.cpf"
                        />
                      </b-col>

                      <b-col cols="12" md="4" class="mb-3">
                        <StandardInput
                          type="text"
                          name="rg"
                          label="RG"
                          v-model="responsible.rg"
                        />
                      </b-col>

                      <b-col cols="12" md="4" class="mb-3">
                        <StandardInput
                          v-if="
                            responsible.Responsible &&
                            responsible.Responsible.User &&
                            responsible.Responsible.User.Phones.length > 0
                          "
                          type="text"
                          name="phone"
                          label="Telefone"
                          v-mask="['(##) #####-####']"
                          v-model="
                            responsible.Responsible.User.Phones[0].number
                          "
                        />
                      </b-col>
                    </b-row>

                    <b-row>
                      <b-col cols="12" md="6" class="mb-3">
                        <StandardInput
                          v-model="responsible.birth_date"
                          type="text"
                          name="birth_date"
                          label="Data de nascimento"
                          v-mask="'##/##/####'"
                          placeholder="DD/MM/AAAA"
                          @input="
                            handleBirthDateInput('contractor', $event, index)
                          "
                        />
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>

                <b-row v-if="responsible.Address" class="mt-4">
                  <b-col cols="12">
                    <h5>Dados de endereço</h5>
                  </b-col>
                </b-row>

                <b-row v-if="responsible.Address">
                  <b-col cols="12" md="3" class="mb-3">
                    <StandardInput
                      type="text"
                      name="cep"
                      label="CEP"
                      v-mask="['#####-###']"
                      v-model="responsible.Address.cep"
                    />
                  </b-col>

                  <b-col cols="12" md="6" class="mb-3">
                    <StandardInput
                      type="text"
                      name="city"
                      label="Cidade"
                      v-model="responsible.Address.city"
                    />
                  </b-col>

                  <b-col cols="12" md="3" class="mb-3">
                    <StandardInput
                      type="text"
                      name="neighborhood"
                      label="Bairro"
                      v-model="responsible.Address.neighborhood"
                    />
                  </b-col>
                </b-row>

                <b-row v-if="responsible.Address">
                  <b-col cols="12" md="6" class="mb-3">
                    <StandardInput
                      type="text"
                      name="address"
                      label="Rua"
                      v-model="responsible.Address.street"
                    />
                  </b-col>

                  <b-col cols="12" md="3" class="mb-3">
                    <StandardInput
                      type="text"
                      name="number"
                      label="Número"
                      v-model="responsible.Address.number"
                    />
                  </b-col>

                  <b-col cols="12" md="3" class="mb-3">
                    <StandardInput
                      type="text"
                      name="complement"
                      label="Complemento"
                      v-model="responsible.Address.complement"
                    />
                  </b-col>
                </b-row>

                <b-row class="divider" style="padding-top: 40px">
                  <b-col></b-col>
                </b-row>
              </b-col>
            </b-row>

            <b-row class="row-buttons mt-4">
              <b-col>
                <b-button
                  @click="updateContractors"
                  class="btn large outline"
                  :class="{ loading: loading.contractors }"
                  :disabled="!isValidContractor() || loading.contractors"
                >
                  <span v-if="loading.contractors"> Atualizando... </span>
                  <span v-else> Atualizar dados </span>
                </b-button>
              </b-col>
            </b-row>
          </b-tab>

          <b-tab title="Dados dos alunos">
            <b-row v-if="enrollmentStudent">
              <b-col cols="12">
                <b-row>
                  <b-col cols="12">
                    <h2 class="purple bold">
                      {{ enrollmentStudent.name }}
                    </h2>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col cols="12">
                    <p class="purple bold">
                      Referente à matrícula {{ enrollment.id }}
                    </p>
                  </b-col>
                </b-row>

                <b-row class="mb-4">
                  <b-col cols="12" md="3" class="mb-3">
                    <ProfilePhoto
                      modalId="studentData"
                      :photo="
                        typeof enrollmentStudent.photo !== 'string'
                          ? photoStudent
                          : enrollmentStudent.photo
                      "
                      :callback="setNewStudentPhoto"
                    />
                  </b-col>

                  <b-col cols="12" md="9">
                    <b-row>
                      <b-col cols="12" md="6" class="mb-3">
                        <StandardInput
                          type="text"
                          name="name"
                          label="Nome"
                          v-model="enrollmentStudent.name"
                        />
                      </b-col>

                      <b-col cols="12" md="6" class="mb-3">
                        <StandardInput
                          type="email"
                          name="email"
                          label="E-mail"
                          v-model="enrollmentStudent.email"
                        />
                      </b-col>
                    </b-row>

                    <b-row>
                      <b-col cols="12">
                        <h5>Documentos</h5>
                      </b-col>
                    </b-row>

                    <b-row>
                      <b-col cols="12" md="6" class="mb-3">
                        <StandardInput
                          type="text"
                          name="cpf"
                          label="CPF"
                          v-mask="['###.###.###-##']"
                          v-model="enrollmentStudent.cpf"
                        />
                      </b-col>

                      <b-col cols="12" md="6" class="mb-3">
                        <StandardInput
                          type="text"
                          name="rg"
                          label="RG"
                          v-model="enrollmentStudent.rg"
                        />
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12" md="6" class="mb-3">
                        <StandardInput
                          v-if="
                            enrollmentStudent.Student.User.Phones.length > 0
                          "
                          type="text"
                          name="phone"
                          label="Telefone"
                          v-mask="['(##) #####-####']"
                          v-model="
                            enrollmentStudent.Student.User.Phones[0].number
                          "
                        />
                      </b-col>

                      <b-col cols="12" md="6" class="mb-3">
                        <StandardInput
                          v-model="enrollmentStudent.birth_date"
                          type="text"
                          name="birth_date"
                          label="Data de nascimento"
                          v-mask="'##/##/####'"
                          placeholder="DD/MM/AAAA"
                          @input="handleBirthDateInput('student', $event)"
                        />
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row v-if="enrollmentStudent.Address" class="mt-4">
                  <b-col cols="12">
                    <h5>Dados de endereço</h5>
                  </b-col>
                </b-row>

                <b-row v-if="enrollmentStudent.Address">
                  <b-col cols="12" md="3" class="mb-3">
                    <StandardInput
                      type="text"
                      name="cep"
                      label="CEP"
                      v-mask="['#####-###']"
                      v-model="enrollmentStudent.Address.cep"
                    />
                  </b-col>

                  <b-col cols="12" md="6" class="mb-3">
                    <StandardInput
                      type="text"
                      name="city"
                      label="Cidade"
                      v-model="enrollmentStudent.Address.city"
                    />
                  </b-col>

                  <b-col cols="12" md="3" class="mb-3">
                    <StandardInput
                      type="text"
                      name="neighborhood"
                      label="Bairro"
                      v-model="enrollmentStudent.Address.neighborhood"
                    />
                  </b-col>
                </b-row>

                <b-row v-if="enrollmentStudent.Address">
                  <b-col cols="12" md="6" class="mb-3">
                    <StandardInput
                      type="text"
                      name="address"
                      label="Rua"
                      v-model="enrollmentStudent.Address.street"
                    />
                  </b-col>

                  <b-col cols="12" md="3" class="mb-3">
                    <StandardInput
                      type="text"
                      name="number"
                      label="Número"
                      v-model="enrollmentStudent.Address.number"
                    />
                  </b-col>

                  <b-col cols="12" md="3" class="mb-3">
                    <StandardInput
                      type="text"
                      name="complement"
                      label="Complemento"
                      v-model="enrollmentStudent.Address.complement"
                    />
                  </b-col>
                </b-row>

                <b-row class="divider" style="padding-top: 40px">
                  <b-col></b-col>
                </b-row>
              </b-col>
            </b-row>

            <b-row class="row-buttons mt-4">
              <b-col>
                <b-button
                  @click="updateStudents"
                  class="btn large outline"
                  :class="{ loading: loading.students }"
                  :disabled="!isValidStudent() || loading.students"
                >
                  <span v-if="loading.students"> Atualizando... </span>
                  <span v-else> Atualizar dados </span>
                </b-button>
              </b-col>
            </b-row>
          </b-tab>

          <b-tab title="Autorizações da matrícula">
            <b-row
              v-for="(authorization, index) in authorizations"
              :key="index"
              class="mb-4"
            >
              <b-col cols="12">
                <h3 class="purple bold">
                  Referente à matrícula {{ authorization.enrollment_id }} do(a)
                  aluno(a)
                  {{ studentNameByEnrollmentId(authorization.enrollment_id) }}
                </h3>

                <Authorizations v-model="authorizations[index]" />

                <b-row class="divider" style="padding-top: 40px">
                  <b-col></b-col>
                </b-row>
              </b-col>
            </b-row>

            <b-row class="row-buttons mt-4">
              <b-col>
                <b-button
                  @click="createUpdateAuthorizations('update')"
                  class="btn large outline"
                  :class="{ loading: loading.authorizations }"
                  :disabled="loading.authorizations"
                >
                  <span v-if="loading.authorizations"> Atualizando... </span>
                  <span v-else> Atualizar dados </span>
                </b-button>
              </b-col>
            </b-row>
          </b-tab>

          <b-tab title="Complementos da matrícula">
            <b-row
              v-for="(complement, index) in complements"
              :key="index"
              class="mb-4"
            >
              <b-col cols="12">
                <p class="purple bold">
                  Referente à matrícula {{ complement.enrollment_id }} do(a)
                  aluno(a)
                  {{ studentNameByEnrollmentId(complement.enrollment_id) }}
                </p>

                <div class="form-content">
                  <Complementary v-model="complements[index]" />
                </div>

                <b-row class="divider" style="padding-top: 40px">
                  <b-col></b-col>
                </b-row>
              </b-col>
            </b-row>

            <b-row class="row-buttons mt-4">
              <b-col>
                <b-button
                  @click="createUpdateComplement('update')"
                  class="btn large outline"
                  :class="{ loading: loading.complements }"
                  :disabled="!isValidComplementary() || loading.complements"
                >
                  <span v-if="loading.complements"> Atualizando... </span>
                  <span v-else> Atualizar dados </span>
                </b-button>
              </b-col>
            </b-row>
          </b-tab>

          <b-tab title="Anexos da matrícula">
            <b-row v-for="(submit, index) in submits" :key="index" class="mb-4">
              <b-col cols="12">
                <p class="purple bold">
                  Referente à matrícula {{ submit.enrollmentId }} do(a) aluno(a)
                  {{ studentNameByEnrollmentId(submit.enrollmentId) }}
                </p>

                <div class="form-content">
                  <Submit
                    v-model="submits[index].structure"
                    :enrollmentId="submits[index].enrollmentId"
                    :editedUserId="submits[index].editedUserId"
                    :enrollmentMeta="enrollment"
                    :id="submit.enrollmentId"
                  />
                </div>

                <b-row class="divider" style="padding-top: 40px">
                  <b-col></b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
    <b-row v-else>
      <b-col>
        <h2 class="purple bold">Atenção!</h2>
        <p>
          Você não tem permissão para editar os dados da matrícula. Por favor,
          entre em contato com a coordenação ou secretaria para obter
          assistência.
        </p>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import DataService from "@/services/user.service";
import store from "../../../../store";
import StandardInput from "@/components/inputs/StandardInput.vue";
import httpRda from "../../../../http-rda";
import Complementary from "../../../enroll/form/Complementary.vue";
import Authorizations from "../../../enroll/form/Authorizations.vue";
import Submit from "../../../enroll/form/Submit.vue";
import ProfilePhoto from "@/components/ProfilePhoto.vue";
import { isPhotoFile } from "@/utils/photo";

import {
  FromBRDateToIsoString,
  FromIsoStringToBRDate,
} from "../../../../utils/fomatDate";

export default {
  name: "EnrollmentData",
  components: {
    StandardInput,
    Complementary,
    Authorizations,
    Submit,
    ProfilePhoto,
  },

  data() {
    return {
      breadcrumb: [
        {
          text: "Comunidade",
          href: "/comunidade",
        },
        {
          text: "Alunos",
          href: "/alunos",
        },
        {
          text: "Dados da matrícula",
          active: true,
        },
      ],
      selected: {
        user: {
          name: "",
          Phones: {},
        },
      },
      loading: {
        contractors: false,
        students: false,
        authorizations: false,
        complements: false,
      },

      photoContractor: [],
      photoStudent: null,
      enrollment: null,
      enrollmentsResponsibles: [],
      enrollmentStudent: null,
      enrollmentsIds: [],
      newPhoto: null,
      blob: null,
      language: "ptBR",
      authorizations: [],
      complements: [],

      validationCache: {
        student: null,
        contractor: null,
        complementary: null,
      },

      SubmitStructure: [
        {
          title: "Carteira de identidade do aluno (Frente e Verso)",
          isRequired: true,
          files: [
            {
              file: null,
              progress: null,
              status: false,
              fileName: "identity",
              url: "",
            },
            {
              file: null,
              progress: null,
              status: false,
              fileName: "identity_back",
              url: "",
            },
          ],
        },
        {
          title: "CPF do aluno",
          isRequired: true,
          files: [
            {
              file: null,
              progress: null,
              status: false,
              fileName: "cpf",
              url: "",
            },
          ],
        },
        {
          title: "Cartão de vacinas do aluno",
          isRequired: true,
          files: [
            {
              file: null,
              progress: null,
              status: false,
              fileName: "vaccination_record",
              url: "",
            },
          ],
        },
        {
          title: "Declaração de quitação emitida pela escola anterior",
          isRequired: true,
          files: [
            {
              file: null,
              progress: null,
              status: false,
              fileName: "discharge",
              url: "",
            },
          ],
        },
        {
          title: "Histórico Escolar/ Registro de Percurso (Educação Infantil)",
          isRequired: false,
          files: [
            {
              file: null,
              progress: null,
              status: false,
              fileName: "school_record",
              url: "",
            },
          ],
        },
        {
          title: "Carteira de identidade do contratante A (Frente e Verso)",
          isRequired: true,
          files: [
            {
              file: null,
              progress: null,
              status: false,
              fileName: "identity_contractor_a",
              url: "",
            },
            {
              file: null,
              progress: null,
              status: false,
              fileName: "identity_contractor_a_back",
              url: "",
            },
          ],
        },
        {
          title: "Carteira de identidade do contratante B (Frente e Verso)",
          isRequired: true,
          files: [
            {
              file: null,
              progress: null,
              status: false,
              fileName: "identity_contractor_b",
              url: "",
            },
            {
              file: null,
              progress: null,
              status: false,
              fileName: "identity_contractor_b_back",
              url: "",
            },
          ],
        },
        {
          title: "CPF dos contratantes",
          isRequired: true,
          files: [
            {
              file: null,
              progress: null,
              status: false,
              fileName: "cpf_contractor_a",
              url: "",
            },
            {
              file: null,
              progress: null,
              status: false,
              fileName: "cpf_contractor_b",
              url: "",
            },
          ],
        },
      ],

      submits: [],
    };
  },

  filters: {
    date(date) {
      try {
        var d = new Date(date.split());
        var year = d.getFullYear();
        var month = (d.getMonth() + 1).toString().padStart(2, "0");
        var day = d.getUTCDate().toString().padStart(2, "0");

        return day + "/" + month + "/" + year;
      } catch (error) {
        return date;
      }
    },
  },

  computed: {
    ...mapGetters({
      currentUser: "auth/getAuthData",
      users: "shared/users",
      students: "shared/studentsCycle",
    }),

    canEdit() {
      if (!this.currentUser.role) {
        return false;
      }
      return ["coordinator", "secretary", "admin"].includes(
        this.currentUser.role[0]
      );
    },
  },

  methods: {
    ...mapActions({
      getUser: "shared/getUser",
      getStudentCycle: "shared/getStudentCycle",
    }),

    handleBirthDateInput(type, event, index = null) {
      const value = event.target ? event.target.value : event;

      if (type === "student" && this.enrollmentStudent.birth_date === value) {
        return;
      }

      if (
        type === "contractor" &&
        index !== null &&
        this.enrollmentsResponsibles.EnrollmentResponsibles[index]
          .birth_date === value
      ) {
        return;
      }

      if (this.isValidDateFormat(value) || value.length <= 10) {
        if (type === "student") {
          this.$set(this.enrollmentStudent, "birth_date", value);
        } else if (type === "contractor" && index !== null) {
          this.$set(
            this.enrollmentsResponsibles.EnrollmentResponsibles[index],
            "birth_date",
            value
          );
        }

        this.clearValidationCache(type);
      }
    },

    isValidDateFormat(date) {
      if (!date) return false;
      const dateRegex = /^\d{2}\/\d{2}\/\d{4}$/;
      return dateRegex.test(date);
    },

    clearValidationCache(type = null) {
      if (type) {
        this.validationCache[type] = null;
      } else {
        this.validationCache = {
          student: null,
          contractor: null,
          complementary: null,
        };
      }
    },

    isCompoundName(name) {
      if (!name) return false;
      name = name.trim();
      const nameArr = name.split(" ");
      return nameArr.length >= 2;
    },

    isValidStudent() {
      if (this.validationCache.student !== null) {
        return this.validationCache.student;
      }

      const student = this.enrollmentStudent;
      if (!student) {
        this.validationCache.student = false;
        return false;
      }

      const isValid = !!(
        student.photo &&
        student.name &&
        this.isCompoundName(student.name) &&
        student.birth_date &&
        this.isValidDateFormat(student.birth_date) &&
        student.Address?.cep &&
        student.Address?.city &&
        student.Address?.neighborhood &&
        student.Address?.street &&
        student.Address?.number &&
        student.email &&
        student.rg &&
        student.cpf
      );

      this.validationCache.student = isValid;
      return isValid;
    },

    isValidContractor() {
      if (this.validationCache.contractor !== null) {
        return this.validationCache.contractor;
      }

      const contractors = this.enrollmentsResponsibles?.EnrollmentResponsibles;
      if (!contractors || contractors.length === 0) {
        this.validationCache.contractor = false;
        return false;
      }

      const isValid = contractors.every((contractor) => {
        return !!(
          contractor.photo &&
          contractor.name &&
          this.isCompoundName(contractor.name) &&
          contractor.birth_date &&
          this.isValidDateFormat(contractor.birth_date) &&
          contractor.Responsible?.User?.Phones?.length > 0 &&
          contractor.Responsible.User.Phones[0].number &&
          contractor.email &&
          contractor.cpf &&
          contractor.rg &&
          this.checkAddressFormFields(contractor)
        );
      });

      this.validationCache.contractor = isValid;
      return isValid;
    },

    isValidComplementary() {
      if (this.validationCache.complementary !== null) {
        return this.validationCache.complementary;
      }

      const complement = this.complements[0];
      if (!complement) {
        this.validationCache.complementary = false;
        return false;
      }

      let validateContacts = true;
      if (complement.return_to_home === "Acompanhado") {
        validateContacts =
          complement.EnrollmentComplementContacts?.every((item) => {
            return !!(
              item.name &&
              item.number1 &&
              item.relationship &&
              item.photo
            );
          }) || false;
      }

      const basicValidation = !!(
        complement.contact1 &&
        complement.contact1_phone &&
        complement.contact2 &&
        complement.contact2_phone
      );

      const conditionalValidations = [
        {
          condition: complement.food_restriction,
          field: complement.food_restriction_description,
        },
        {
          condition: complement.health_problem,
          field: complement.health_problem_description,
        },
        {
          condition: complement.healthcare,
          field: complement.healthcare_description,
        },
        {
          condition: complement.limitation,
          field: complement.limitation_description,
        },
        {
          condition: complement.special_accompaniment,
          field: complement.special_accompaniment_description,
        },
        {
          condition: complement.special_care,
          field: complement.special_care_description,
        },
      ].every(({ condition, field }) => !condition || field);

      const isValid =
        basicValidation && conditionalValidations && validateContacts;
      this.validationCache.complementary = isValid;
      return isValid;
    },

    checkAddressFormFields(item) {
      return !!(
        item.Address?.cep &&
        item.Address?.number &&
        item.Address?.street &&
        item.Address?.neighborhood &&
        item.Address?.city
      );
    },

    isValid(type) {
      switch (type) {
        case "Student":
          return this.isValidStudent();
        case "Contractor":
          return this.isValidContractor();
        case "Complementary":
          return this.isValidComplementary();
        default:
          return false;
      }
    },

    setNewPhotoContractor(photo, index) {
      const bodyFormData = new FormData();
      bodyFormData.append("file", photo);
      bodyFormData.append("notification", true);
      this.enrollmentsResponsibles.EnrollmentResponsibles[index].photo =
        bodyFormData;
      this.photoContractor[index] = photo;
      this.clearValidationCache("contractor");
    },

    setNewStudentPhoto(photo) {
      const bodyFormData = new FormData();
      bodyFormData.append("file", photo);
      bodyFormData.append("notification", true);
      this.enrollment.EnrollmentStudent.photo = bodyFormData;
      this.photoStudent = photo;
      this.clearValidationCache("student");
    },

    async getAllUserEnrollments() {
      try {
        this.enrollment = await httpRda
          .get(`/students/${this.$route.params.id}/enrollment-data`)
          .then((response) => response.data.enrollment);

        this.enrollmentStudent = this.enrollment.EnrollmentStudent;
        for (const responsible of this.enrollment.EnrollmentResponsibles) {
          responsible.birth_date = FromIsoStringToBRDate(
            responsible.birth_date
          );
        }

        this.enrollment.EnrollmentStudent.birth_date = FromIsoStringToBRDate(
          this.enrollment.EnrollmentStudent.birth_date
        );

        this.submits.push({
          structure: JSON.parse(JSON.stringify(this.SubmitStructure)),
          enrollmentId: this.enrollment.id,
          editedUserId: this.enrollment.EnrollmentStudent.Student.User.id,
        });

        this.enrollmentsResponsibles = this.enrollment;
        this.enrollmentsIds.push(this.enrollment.id);

        await this.createUpdateAuthorizations("get");
        await this.createUpdateComplement("get");
      } catch (error) {
        this.$swal.fire({
          icon: "error",
          title: "Erro ao carregar dados",
          text: "Não foi possível carregar os dados da matrícula.",
          footer: "Por favor, tente novamente mais tarde.",
        });
      }
    },

    studentNameByEnrollmentId() {
      return this.enrollment?.EnrollmentStudent?.name || "";
    },

    setUser() {
      const user = store.getters["auth/getAuthData"];
      this.user_id = user.id;
      this.getUser(user.id);
    },

    async createNotification(userEditorId, userEditedId, details) {
      try {
        await httpRda.post("/notifications", {
          user_editor_id: userEditorId,
          user_edited_id: userEditedId,
          details,
        });
      } catch (_) {
        //
      }
    },

    async updateContractors() {
      if (!this.isValidContractor()) {
        this.$swal.fire({
          icon: "warning",
          title: "Dados inválidos",
          text: "Por favor, preencha todos os campos obrigatórios antes de atualizar.",
        });
        return;
      }

      this.loading.contractors = true;

      try {
        for (
          let index = 0;
          index < this.enrollmentsResponsibles.EnrollmentResponsibles.length;
          index++
        ) {
          const responsible =
            this.enrollmentsResponsibles.EnrollmentResponsibles[index];

          try {
            const address = {
              cep: responsible.Address?.cep?.replace("-", "") || "",
              number: responsible.Address?.number || "",
              complement: responsible.Address?.complement || "",
              street: responsible.Address?.street || "",
              neighborhood: responsible.Address?.neighborhood || "",
              city: responsible.Address?.city || "",
              state: responsible.Address?.state || "",
              country: responsible.Address?.country || "",
            };

            await DataService.updateAddress(
              responsible.Responsible.User.id,
              address
            );

            const payload = {
              birth_date: FromBRDateToIsoString(responsible.birth_date),
              Phones: responsible.Responsible.User.Phones,
              email: responsible.email,
              name: responsible.name,
              cpf: responsible.cpf,
              rg: responsible.rg,
              Address: responsible.Responsible.User.Address,
            };

            await DataService.update(responsible.Responsible.User.id, {
              ...payload,
              notification: true,
            });

            if (
              typeof responsible.photo === "object" &&
              this.photoContractor[index]
            ) {
              await httpRda.patch(
                `/users/${responsible.Responsible.User.id}`,
                responsible.photo,
                {
                  headers: { "Content-Type": "multipart/form-data" },
                }
              );
            }
          } catch (error) {
            console.error(`Erro ao atualizar contratante ${index}:`, error);
            throw error;
          }
        }

        const Toast = this.$swal.mixin({
          toast: true,
          position: "bottom-end",
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", this.$swal.stopTimer);
            toast.addEventListener("mouseleave", this.$swal.resumeTimer);
          },
        });

        Toast.fire({
          icon: "success",
          title: "Dados dos contratantes atualizados com sucesso!",
        });
      } catch (error) {
        console.error("Erro ao atualizar contratantes:", error);
        this.$swal.fire({
          icon: "error",
          title: "Erro ao atualizar",
          text: "Não foi possível atualizar os dados dos contratantes.",
          footer: "Por favor, tente novamente mais tarde.",
        });
      } finally {
        this.loading.contractors = false;
      }
    },

    async updateStudents() {
      if (!this.isValidStudent()) {
        this.$swal.fire({
          icon: "warning",
          title: "Dados inválidos",
          text: "Por favor, preencha todos os campos obrigatórios antes de atualizar.",
        });
        return;
      }

      this.loading.students = true;

      try {
        const address = {
          cep:
            this.enrollment.EnrollmentStudent.Address?.cep?.replace("-", "") ||
            "",
          number: this.enrollment.EnrollmentStudent.Address?.number || "",
          complement:
            this.enrollment.EnrollmentStudent.Address?.complement || "",
          street: this.enrollment.EnrollmentStudent.Address?.street || "",
          neighborhood:
            this.enrollment.EnrollmentStudent.Address?.neighborhood || "",
          city: this.enrollment.EnrollmentStudent.Address?.city || "",
          state: this.enrollment.EnrollmentStudent.Address?.state || "",
          country: this.enrollment.EnrollmentStudent.Address?.country || "",
        };

        await DataService.updateAddress(
          this.enrollment.EnrollmentStudent.Student.User.id,
          address
        );

        const payload = {
          birth_date: FromBRDateToIsoString(
            this.enrollment.EnrollmentStudent.birth_date
          ),
          Phones: this.enrollment.EnrollmentStudent.Student.User.Phones,
          email: this.enrollment.EnrollmentStudent.email,
          name: this.enrollment.EnrollmentStudent.name,
          cpf: this.enrollment.EnrollmentStudent.cpf,
          rg: this.enrollment.EnrollmentStudent.rg,
          Address: this.enrollment.EnrollmentStudent.Address,
        };

        await httpRda.patch(
          `/users/${this.enrollment.EnrollmentStudent.Student.User.id}/student`,
          { ...payload, notification: true }
        );

        if (
          typeof this.enrollment.EnrollmentStudent.photo === "object" &&
          this.photoStudent
        ) {
          await httpRda.patch(
            `/users/${this.enrollment.EnrollmentStudent.Student.User.id}/student`,
            this.enrollment.EnrollmentStudent.photo,
            {
              headers: { "Content-Type": "multipart/form-data" },
            }
          );
        }

        const Toast = this.$swal.mixin({
          toast: true,
          position: "bottom-end",
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", this.$swal.stopTimer);
            toast.addEventListener("mouseleave", this.$swal.resumeTimer);
          },
        });

        Toast.fire({
          icon: "success",
          title: "Dados do estudante atualizados com sucesso!",
        });
      } catch (error) {
        console.error("Erro ao atualizar estudante:", error);
        this.$swal.fire({
          icon: "error",
          title: "Erro ao atualizar",
          text: "Não foi possível atualizar os dados do estudante.",
          footer: "Por favor, tente novamente mais tarde.",
        });
      } finally {
        this.loading.students = false;
      }
    },

    getSelected(id) {
      DataService.get(id)
        .then((response) => {
          this.selected = response.data;
          this.selected.user.birth_date = FromIsoStringToBRDate(
            this.selected.user.birth_date
          );
          return response.data;
        })
        .catch((error) => {
          return error.response;
        });
    },

    getCurrentEnrollmentById() {
      return this.enrollment;
    },

    async createUpdateAuthorizations(type) {
      if (type === "update" || type === "post") {
        this.loading.authorizations = true;
      }
      try {
        switch (type) {
          case "update":
          case "post": {
            for (const authorization of this.authorizations) {
              const currentEnrollment = this.getCurrentEnrollmentById(
                authorization.enrollment_id
              );

              await httpRda.post(
                `/enrollments/${authorization.enrollment_id}/authorization`,
                {
                  ...authorization,
                  userId: currentEnrollment.EnrollmentStudent.Student.User.id,
                  notification: true,
                }
              );
            }

            const Toast = this.$swal.mixin({
              toast: true,
              position: "bottom-end",
              showConfirmButton: false,
              timer: 5000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
              },
            });

            Toast.fire({
              icon: "success",
              title: "Autorizações atualizadas com sucesso!",
            });
            break;
          }
          default: {
            for (const enrollmentId of this.enrollmentsIds) {
              const response = await httpRda.get(
                `/enrollments/${enrollmentId}/authorization`
              );
              this.authorizations.push(response.data.authorization);
            }
            break;
          }
        }
      } catch (error) {
        this.$swal.fire({
          icon: "error",
          title: "Erro",
          text: "Não foi possível processar as autorizações.",
          footer: "Por favor, tente novamente mais tarde.",
        });
      } finally {
        if (type === "update" || type === "post") {
          this.loading.authorizations = false;
        }
      }
    },

    async createUpdateComplement(type) {
      if (type === "update" || type === "post") {
        this.loading.complements = true;
      }

      try {
        switch (type) {
          case "update":
          case "post": {
            for (const complement of this.complements) {
              const currentEnrollment = this.getCurrentEnrollmentById(
                complement.enrollment_id
              );

              await httpRda.patch(
                `/enrollments/${complement.enrollment_id}/complement`,
                {
                  complement: {
                    ...complement,
                    userId: currentEnrollment.EnrollmentStudent.Student.User.id,
                    notification: true,
                  },
                  id: complement.enrollment_id,
                }
              );

              await this.createUpdateContacts(complement.enrollment_id, {
                ...complement,
                userId: currentEnrollment.EnrollmentStudent.Student.User.id,
                notification: true,
              });
            }

            const Toast = this.$swal.mixin({
              toast: true,
              position: "bottom-end",
              showConfirmButton: false,
              timer: 5000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
              },
            });

            Toast.fire({
              icon: "success",
              title: "Complementos atualizados com sucesso!",
            });
            break;
          }
          default: {
            for (const enrollmentId of this.enrollmentsIds) {
              const response = await httpRda.get(
                `/enrollments/${enrollmentId}/complement`
              );
              this.complements.push(response.data.enrollment_complement);
            }
            break;
          }
        }
      } catch (error) {
        this.$swal.fire({
          icon: "error",
          title: "Erro",
          text: "Não foi possível processar os complementos.",
          footer: "Por favor, tente novamente mais tarde.",
        });
      } finally {
        if (type === "update" || type === "post") {
          this.loading.complements = false;
        }
      }
    },

    async createUpdateContacts(id, complementary) {
      if (complementary.return_to_home !== "Sozinho") {
        const toUpdate =
          complementary.EnrollmentComplementContacts?.filter(
            (contact) => contact.id !== undefined
          ) || [];

        const toCreate =
          complementary.EnrollmentComplementContacts?.filter(
            (contact) => contact.id === undefined
          ) || [];

        try {
          if (toUpdate.length) {
            for (const { photo, ...contact } of toUpdate) {
              await httpRda.patch(`/enrollments/${id}/contacts/${contact.id}`, {
                ...contact,
                notification: complementary.notification,
                userId: complementary.userId,
              });

              if (isPhotoFile(photo)) {
                const bodyFormData = new FormData();
                bodyFormData.append("file", photo);

                await httpRda.patch(
                  `enrollments/${id}/contacts/${contact.id}`,
                  bodyFormData,
                  {
                    headers: { "Content-Type": "multipart/form-data" },
                  }
                );
              }
            }
          }

          if (toCreate.length) {
            for (const { photo, ...contact } of toCreate) {
              const response = await httpRda.post(
                `/enrollments/${id}/contacts`,
                {
                  ...contact,
                  notification: complementary.notification,
                  userId: complementary.userId,
                }
              );

              if (isPhotoFile(photo)) {
                const newId = response.data.complement.find(
                  (item) => item.name === contact.name
                ).id;

                const bodyFormData = new FormData();
                bodyFormData.append("file", photo);

                await httpRda.patch(
                  `enrollments/${id}/contacts/${newId}`,
                  bodyFormData,
                  {
                    headers: { "Content-Type": "multipart/form-data" },
                  }
                );
              }
            }
          }
        } catch (error) {
          console.error("Erro ao processar contatos:", error);
          throw error;
        }
      }
    },
  },

  created() {
    this.setUser();
    this.getAllUserEnrollments();
  },

  mounted() {
    if (this.user_id) {
      this.getSelected(this.user_id);
    }
  },

  watch: {
    currentUser() {
      this.setUser();
    },

    enrollmentsResponsibles: {
      handler() {
        this.clearValidationCache("contractor");
      },
      deep: true,
    },

    enrollmentStudent: {
      handler() {
        this.clearValidationCache("student");
      },
      deep: true,
    },

    complements: {
      handler() {
        this.clearValidationCache("complementary");
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables.scss";

[id*="accordion-"] {
  border-bottom: 1px solid #b3b3b3;
  padding-bottom: 30px;
}

.tab-content {
  .nav-tabs {
    border-bottom: 2px solid #e6e6e6;
    gap: 24px;

    li {
      &:first-child {
        a {
          text-align: left;
          padding: 0;
        }
      }
    }

    .nav-link {
      text-align: center;
      font-size: 18px;
      color: #1a1a1a;
      height: 52px;
      border: 0;
      padding: 0 18px;
      position: relative;

      &.active {
        font-weight: bold;
        background: transparent;

        &:after {
          width: 100%;
        }
      }

      &:after {
        background: $gradient1;
        content: "";
        width: 0;
        height: 4px;
        display: block;
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        border-radius: 50px;
        transition: 0.2s all ease-in-out;
      }
    }
  }
}

.divider {
  position: relative;

  p {
    min-height: 70px;
  }

  &:after {
    background-color: $grey7;
    content: "";
    display: block;
    height: 1px;
    left: 0;
    top: 50%;
    position: absolute;
    width: 100%;
  }
}

.profile-row {
  background: $gradient3;
  border-radius: 10px;
  color: $white;
  margin: 30px 0 40px;
  padding: 28px 10px;
  position: relative;

  &:after {
    content: url("~@/assets/images/watermark-profile.png");
    right: 0;
    pointer-events: none;
    position: absolute;
    top: -5px;
  }

  .col {
    display: flex;
    align-items: center;

    img {
      margin-right: 40px;
    }

    .content-profile {
      h5 {
        margin-bottom: 14px;
      }

      p {
        margin: 0;
      }
    }
  }
}

.form-group {
  margin-bottom: 40px;
}

.title {
  padding: 20px 15px 40px;

  h5 {
    margin: 0;
  }
}

.row-buttons {
  padding-top: 10px;
}

#StandardInput_birth_date,
input[name="birth_date"] {
  height: 48.67px;
}

@media (max-width: 768px) {
  .tab-content .nav-tabs {
    flex-direction: column;
    gap: 12px;

    .nav-link {
      text-align: left;
      font-size: 16px;
      height: auto;
      padding: 12px 0;
    }
  }

  .form-group {
    margin-bottom: 24px;
  }

  .profile-row {
    margin: 20px 0 30px;
    padding: 20px 15px;

    .col {
      flex-direction: column;
      text-align: center;

      img {
        margin-right: 0;
        margin-bottom: 20px;
      }
    }
  }
}

.form-group.has-error {
  .form-control {
    border-color: #dc3545;
    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
  }
}

.form-group.has-success {
  .form-control {
    border-color: #28a745;
    box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
  }
}

.btn {
  position: relative;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  &.loading {
    &:after {
      content: "";
      position: absolute;
      width: 16px;
      height: 16px;
      margin: auto;
      border: 2px solid transparent;
      border-top-color: #ffffff;
      border-radius: 50%;
    }
  }
}

.form-control {
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

  &:focus {
    border-color: #80bdff;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  }

  &.is-invalid {
    border-color: #dc3545;

    &:focus {
      border-color: #dc3545;
      box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
    }
  }

  &.is-valid {
    border-color: #28a745;

    &:focus {
      border-color: #28a745;
      box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
    }
  }
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.mb-4 {
  margin-bottom: 1.5rem !important;
}

.mt-4 {
  margin-top: 1.5rem !important;
}

h2.purple.bold {
  color: #6f42c1;
  font-weight: 700;
  margin-bottom: 1rem;
}

h5 {
  color: #495057;
  font-weight: 600;
  margin-bottom: 0.75rem;
}

p.purple.bold {
  color: #6f42c1;
  font-weight: 600;
}

@media (max-width: 576px) {
  .form-group {
    margin-bottom: 1rem;
  }

  h2.purple.bold {
    font-size: 1.5rem;
  }

  .btn.large {
    width: 100%;
    padding: 12px 24px;
  }
}

.required-field {
  position: relative;

  &:after {
    content: "*";
    color: #dc3545;
    position: absolute;
    top: 0;
    right: -10px;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.divider {
  margin: 2rem 0;

  &:after {
    background: linear-gradient(90deg, transparent, #dee2e6, transparent);
    height: 1px;
  }
}

.btn {
  position: relative;
  transition: all 0.3s ease;

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }

  &.loading {
    opacity: 0.8;
    cursor: wait;

    animation: pulse-loading 1.5s infinite;
  }
}

@keyframes pulse-loading {
  0% {
    opacity: 0.7;
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 0.7;
  }
}

.mr-2 {
  margin-right: 0.5rem;
}

.btn.outline {
  &.loading {
    background-color: rgba(108, 117, 125, 0.1);
    border-color: #6c757d;
    color: #6c757d;
  }

  &:disabled {
    background-color: transparent;
    border-color: #dee2e6;
    color: #6c757d;
  }
}

.loading-overlay {
  position: relative;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.8);
    z-index: 1;
    border-radius: inherit;
  }

  &::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 20px;
    height: 20px;
    margin: -10px 0 0 -10px;
    border: 2px solid #f3f3f3;
    border-top: 2px solid #3498db;
    border-radius: 50%;
    z-index: 2;
  }
}
</style>
